// @flow
import React from 'react'
import I18n from 'i18n-react'
import { humanizer } from 'devx-js-utilities'

// types
import type { ColumnTypeDefaultProps } from './ColumnTypeDefault'

const ColumnTypeInsuranceLimits = (props: ColumnTypeDefaultProps) => {
  if (props.data && props.data.health) {
    return (
      <div className='text-lg-center'>
        <span className='mobile-label d-table-cell d-lg-none w-100 py-1 pl-2'>{I18n.translate('general.participation')}&nbsp;</span>

        <div className='align-middle d-table-cell d-lg-inline-block text-nowrap pr-2 pr-lg-0 text-right text-lg-left'>
          <strong className='d-lg-block'>{props.data.health}/{props.data.property}</strong>&nbsp;
          <strong>mil. {I18n.translate('general.currency')}</strong>
        </div>
      </div>
    )
  } else if (props.quote.subProductToTariffName.cic && props.data) {
    const limitsData = props.data
    return (
      <div className='text-lg-center'>
        <span className='mobile-label d-table-cell d-lg-none w-100 py-1 pl-2'>{I18n.translate('general.participation')}&nbsp;</span>

        <div className='align-middle d-table-cell d-lg-inline-block text-nowrap pr-2 pr-lg-0 text-right text-lg-left'>
          {typeof limitsData.percent !== 'undefined' && <strong className='d-lg-block'>{`${limitsData.percent}%`}</strong>}
          {limitsData.value &&
          <strong>
            {typeof limitsData.percent !== 'undefined' ? 'min.' : ''}&nbsp;
            {humanizer.csNumber(limitsData.value)}&nbsp;
            {I18n.translate('general.currency')}
          </strong>
          }
        </div>
      </div>
    )
  }
  return null
}

export default ColumnTypeInsuranceLimits
